import { fetchBlogsData, fetchBlogData } from "./actions/fetchActions";
import {
  blogsReducer,
  blogReducer,
  createBlogReducer,
  updateBlogReducer,
  deleteBlogReducer,
} from "./reducers/fetchReducers";

const blogsReducers = {
  blogsGlobalStore: blogsReducer,
  blogGlobalStore: blogReducer,
  createBlogGlobalStore: createBlogReducer,
  updateBlogGlobalStore: updateBlogReducer,
  deleteBlogGlobalStore: deleteBlogReducer,
};

export { fetchBlogsData, fetchBlogData, blogsReducers };
